module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp2-c3331585f5912327ca136c531d4dc831.jpg";